import { render, staticRenderFns } from "./OrderClientVerify.vue?vue&type=template&id=194aa715&"
import script from "./OrderClientVerify.vue?vue&type=script&lang=js&"
export * from "./OrderClientVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports